import React from "react";
import { useNavigate } from "react-router-dom";
import IraiList from "../components/IraiList";
import { useData } from "../utils/DataContext";
import {
  Box,
  Button,
  IconButton,
  Typography,
  Tabs,
  Tab,
  Paper,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useSessionStorage } from "../utils/useSessionStorage";

const IraiListHospital: React.FC = () => {
  const navigate = useNavigate();
  const { iraiData, refreshData } = useData();

  // タブ選択の永続化（sessionStorage）- 0: 法令（初期表示）、1: 一覧
  const [tab, setTab] = useSessionStorage<number>("iraiListHospital_tab", 0);

  // statusId="30"（承認待ち）件数
  const pendingApprovalCount = iraiData.filter(
    (irai) => irai.statusId === "30" || irai.statusId === 30,
  ).length;

  const handleNewRequest = (): void => {
    navigate("/newIrai", { state: { irai: null } });
  };

  const handleRefresh = (): void => {
    refreshData(true);
  };

  return (
    <>
      {/* タブ切り替え */}
      <div className="container pt-3">
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          aria-label="hospital-tabs"
          textColor="primary"
          indicatorColor="primary"
          sx={{
            bgcolor: "#f5f5f5",
            borderRadius: 1,
            minHeight: 36,
            "& .MuiTab-root": {
              bgcolor: "#dcdcdc",
              mx: 0.5,
              borderRadius: 1,
              minHeight: 36,
              py: 0.5,
              "&.Mui-selected": {
                bgcolor: "#b0b0b0",
                fontWeight: "bold",
              },
            },
          }}
        >
          <Tab label="法令" />
          <Tab label="一覧" />
        </Tabs>
      </div>

      {/* 一覧タブのときは従来ヘッダーを表示 */}
      {tab === 1 && (
        <div className="container header2 pt-4">
          <Box
            sx={{
              borderRadius: 1,
              boxShadow: 1,
              color: "white",
              bgcolor: "primary.main",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 1,
              px: 2,
              py: 1,
            }}
          >
            <Typography variant="subtitle1" component="h1">
              依頼一覧
              {pendingApprovalCount > 0 && (
                <span style={{ marginLeft: 8, fontSize: "0.9em", color: "#ffeb3b" }}>
                  （承認待ち {pendingApprovalCount} 件）
                </span>
              )}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <IconButton
                onClick={handleRefresh}
                sx={{
                  color: "white",
                  "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" },
                }}
                title="再読み込み"
              >
                <RefreshIcon />
              </IconButton>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleNewRequest}
                sx={{ textTransform: "none", fontSize: "14px", px: 1.5, py: 0.5 }}
              >
                + 新規依頼登録
              </Button>
            </Box>
          </Box>
        </div>
      )}

      {/* タブ内容 */}
      {tab === 0 ? (
        // 法令（固定画面）
        <div className="container body2">
          <Paper sx={{ p: 2 }}>
            <Typography variant="subtitle1" sx={{ mb: 2 }}>
              法定表示ラベル、添付文書（および関連文書）
            </Typography>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
              法定表示ラベル
            </Typography>
            <Table size="small" sx={{ border: "1px solid #ddd" }}>
              <TableBody>
                <TableRow>
                  <TableCell sx={{ width: 160, fontWeight: "bold" }}>種別</TableCell>
                  <TableCell>高度管理医療機器 701 疾病診断用プログラム</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>一般的名称</TableCell>
                  <TableCell>腫瘍悪性度判定支援プログラム</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>JMDN</TableCell>
                  <TableCell>61231003</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>販売名</TableCell>
                  <TableCell>GXP21</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>承認番号</TableCell>
                  <TableCell>29298384478(仮)</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>バージョン情報</TableCell>
                  <TableCell>1.00.00-489939</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>製造販売元</TableCell>
                  <TableCell>株式会社3-Age</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Paper>
        </div>
      ) : (
        // 一覧（従来表示）
        <div className="container body2">
          <IraiList />
        </div>
      )}
    </>
  );
};

export default IraiListHospital;
